/* unplugin-vue-components disabled */import { render } from "./UiIcon.vue?vue&type=template&id=3b67f70e&scoped=true"
import script from "./UiIcon.vue?vue&type=script&lang=js"
export * from "./UiIcon.vue?vue&type=script&lang=js"

import "./UiIcon.vue?vue&type=style&index=0&id=3b67f70e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b67f70e"]])

export default __exports__